import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
// assets
import LogoImage from '../../../assets/logo.png';

import Image from './Image';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink, sx }) {
  const logo = <Box sx={{ width: 40, height: 40, ...sx }}>{/* <Image src={LogoImage} />       */}</Box>;

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
